import { useProgram } from "@modules/programs/hooks/usePrograms"
import { ProgramSubscribersListForOnOffAndInfinite } from "@modules/programs/programSubscriber/components/programSubscribersListForOnOffAndInfinite"
import { ProgramSubscribersListForPro } from "@modules/programs/programSubscriber/components/programSubscribersListForPro"
import { ProgramType } from "@modules/programs/types/programTypes"

type ProgramSubscribersListWrapperProps = {
  programId: string
  className?: string
} & React.ComponentProps<"div">

export function ProgramSubscribersListWrapper({ programId, className, ...props }: ProgramSubscribersListWrapperProps) {
  const { data: program } = useProgram(programId)

  return (
    <>
      {program.type === ProgramType.PRO ? (
        <ProgramSubscribersListForPro programId={programId} className={className} {...props} />
      ) : (
        <ProgramSubscribersListForOnOffAndInfinite programId={programId} className={className} {...props} />
      )}
    </>
  )
}
